import { render, staticRenderFns } from "./DiagCorpHeader.vue?vue&type=template&id=1e604d44&scoped=true&"
import script from "./DiagCorpHeader.vue?vue&type=script&lang=js&"
export * from "./DiagCorpHeader.vue?vue&type=script&lang=js&"
import style0 from "./DiagCorpHeader.vue?vue&type=style&index=0&id=1e604d44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e604d44",
  null
  
)

export default component.exports